/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_Updateavatar1Inputs */

const id_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbarui Avatar`)
};

const ms_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas Kini Avatar`)
};

const da_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdater Avatar`)
};

const de_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar aktualisieren`)
};

const en_us2_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Avatar`)
};

const es_es2_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar avatar`)
};

const es_mx2_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar avatar`)
};

const fil_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-update ang Avatar`)
};

const fr_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour l'avatar`)
};

const it_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna avatar`)
};

const hu_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar frissítése`)
};

const nl_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar bijwerken`)
};

const no_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppdater avatar`)
};

const pl_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizuj awatar`)
};

const pt_br2_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar Avatar`)
};

const pt_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar avatar`)
};

const ro_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizează avatarul`)
};

const fi_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä avatar`)
};

const sv_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdatera avatar`)
};

const vi_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật ảnh đại diện`)
};

const tr_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatarı Güncelle`)
};

const cs_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizovat avatar`)
};

const bg_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Актуализиране на аватар`)
};

const ru_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить аватар`)
};

const uk_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оновити аватар`)
};

const ar_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث الصورة الرمزية`)
};

const hi_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवतार अपडेट करें`)
};

const th_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตรูปโปรไฟล์`)
};

const ja_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アバターを更新`)
};

const zh_cn2_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新头像`)
};

const zh_hant1_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新大頭貼`)
};

const ko_profile_avatar_updateavatar1 = /** @type {(inputs: Profile_Avatar_Updateavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아바타 업데이트`)
};

/**
* | output |
* | --- |
* | "Update Avatar" |
*
* @param {Profile_Avatar_Updateavatar1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_updateavatar1 = /** @type {((inputs?: Profile_Avatar_Updateavatar1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_Updateavatar1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_updateavatar1(inputs)
	if (locale === "ms") return ms_profile_avatar_updateavatar1(inputs)
	if (locale === "da") return da_profile_avatar_updateavatar1(inputs)
	if (locale === "de") return de_profile_avatar_updateavatar1(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_updateavatar1(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_updateavatar1(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_updateavatar1(inputs)
	if (locale === "fil") return fil_profile_avatar_updateavatar1(inputs)
	if (locale === "fr") return fr_profile_avatar_updateavatar1(inputs)
	if (locale === "it") return it_profile_avatar_updateavatar1(inputs)
	if (locale === "hu") return hu_profile_avatar_updateavatar1(inputs)
	if (locale === "nl") return nl_profile_avatar_updateavatar1(inputs)
	if (locale === "no") return no_profile_avatar_updateavatar1(inputs)
	if (locale === "pl") return pl_profile_avatar_updateavatar1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_updateavatar1(inputs)
	if (locale === "pt") return pt_profile_avatar_updateavatar1(inputs)
	if (locale === "ro") return ro_profile_avatar_updateavatar1(inputs)
	if (locale === "fi") return fi_profile_avatar_updateavatar1(inputs)
	if (locale === "sv") return sv_profile_avatar_updateavatar1(inputs)
	if (locale === "vi") return vi_profile_avatar_updateavatar1(inputs)
	if (locale === "tr") return tr_profile_avatar_updateavatar1(inputs)
	if (locale === "cs") return cs_profile_avatar_updateavatar1(inputs)
	if (locale === "bg") return bg_profile_avatar_updateavatar1(inputs)
	if (locale === "ru") return ru_profile_avatar_updateavatar1(inputs)
	if (locale === "uk") return uk_profile_avatar_updateavatar1(inputs)
	if (locale === "ar") return ar_profile_avatar_updateavatar1(inputs)
	if (locale === "hi") return hi_profile_avatar_updateavatar1(inputs)
	if (locale === "th") return th_profile_avatar_updateavatar1(inputs)
	if (locale === "ja") return ja_profile_avatar_updateavatar1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_updateavatar1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_updateavatar1(inputs)
	return ko_profile_avatar_updateavatar1(inputs)
});
export { profile_avatar_updateavatar1 as "profile.avatar.updateAvatar" }